<template>
  <div class="FilterBar">
    <div class="FilterBar-toggles">
      <button 
        class="FilterBar-toggle FilterBar-toggle--filters js-Toggle" 
        type="button" 
        aria-controls="filters"
        :aria-expanded="isOverlayOpen"
        @click="isOverlayOpen = !isOverlayOpen"
        >
        <icon class="FilterBar-toggleIcon" name="filter-list"/> Filter
      </button>

      <div class="FilterBar-toggle FilterBar-toggle--sort">
        <label for="sort-1">
          <icon class="FilterBar-toggleIcon" name="sort"/> Sort
        </label>
        <select class="FilterBar-sort" name="sort" id="sort-1" v-model="state.sortBy">
           <option v-for="(option) in sortOptions" :value="option.value" :key="option.value">
            {{option.label || option.value}}
           </option>
        </select>
      </div>
    </div>
    
    <div class="FilterBar-filters" :class="{ ['is-expanded']: isOverlayOpen }" id="filters" :hidden="!isOverlayOpen">
      <div class="FilterBar-filtersInner">
        <filter-vue v-for="(facet, i) in facets" :label="facet.label" :options="facet.options" :key="i" v-model="state.filters[facet.name]"/>
      </div>
      <div class="FilterBar-apply">
        <button-vue label="Apply filters" :isPrimary="true" :isBlock="true" @click="isOverlayOpen = false"/>
      </div>
    </div>

    <div v-if="perPageOptions || sortOptions" class="FilterBar-controls">
      <filter-select v-if="perPageOptions" label="Per page" :options="perPageOptions" v-model="state.perPage" />
      <filter-select v-if="sortOptions" label="Sort by" :options="sortOptions" v-model="state.sortBy" />
    </div>
  </div>
</template>

<script>
import Icon from '../UI/Icon.vue';
import FilterVue from '../UI/Filter.vue';
import ButtonVue from '../UI/Button.vue';
import FilterSelect from './FilterSelect.vue';

export default {
  inject: ["mq"],
  emits: ['update:state'],
  components: { Icon, FilterVue, FilterSelect, ButtonVue },

  props: {
    state: {
      type: Object,
      default: () => ({
        filters: {},
        sortBy: null,
        perPage: null
      })
    },
    facets: Array,
    sortOptions: Array,
    perPageOptions: Array
  },

  data () {
    return {
      isOverlayOpen: this.mq.largePlus,
    };
  },

  watch: {
    ['mq.largePlus']: function() {
      this.isOverlayOpen = this.mq.largePlus;
    },
    state: {
      handler(val){
        this.$emit('update:state', this.state);
      },
      deep: true
    }
  }
}
</script>